// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__zFFU1","footer":"Form_footer__3VG9e"};